import { Component, inject } from '@angular/core';
import { CommonModule, DOCUMENT, NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PageDialogComponent } from '../page-dialog/page-dialog.component';
import { ConfigService } from '../../services/config/config.service';

@Component({
	selector: 'app-session-time-out',
	standalone: true,
	imports: [CommonModule, MatButtonModule, MatIconModule, PageDialogComponent],
	templateUrl: './session-time-out.component.html',
	styleUrl: './session-time-out.component.scss'
})
export class SessionTimeOutComponent {

	private configService = inject(ConfigService)
	public data: { code: number } = inject(MAT_DIALOG_DATA)
	private document = inject(DOCUMENT)

	reload(): void {
		const win = this.document.defaultView!
		const url = new URL(win.location.toString())

		let theUrl = url.origin + '/eacat'
		if (theUrl.startsWith('http://')) {
			theUrl = this.configService.config.serverAddress
		}

		win.location.href = theUrl
	}
}